import getRouterView from '@/router/helpers';

export default {
    path: '/credit-memo',
    meta: {
        requiresAuth: true,
        title: 'Search',
        documentTitle: 'Credit Memos',
    },
    component: getRouterView(),
    children: [
        {
            path: '',
            name: 'CreditMemoReconciliationSearch',
            meta: {
                title: 'Return Transaction Search',
                documentTitle: 'Credit Memos',
            },
            component: () => import( /* webpackChunkName: "CreditMemoReconciliation" */ '@/views/CreditMemo/Search' ),
        },
        {
            path: 'create',
            name: 'CreditMemoReconciliationCreate',
            meta: {
                title: 'Credit Memo Create',
                documentTitle: 'Credit Memo Create',
            },
            component: () => import( /* webpackChunkName: "CreditMemoReconciliation" */ '@/views/CreditMemo/Create' ),
        },
        {
            path: ':id',
            name: 'CreditMemoReconciliationDetail',
            meta: {
                title: 'Credit Memo Reconciliation Detail',
                documentTitle: 'Credit Memo Reconciliation',
            },
            component: () => import( /* webpackChunkName: "CreditMemoReconciliation" */ '@/views/CreditMemo/Detail' ),
        },
    ],
};
